import React, { useState } from 'react';
import { Header, Icon, Loader, Message } from 'semantic-ui-react';

import { useGetZendeskUnassignedCommunications } from './hooks';
import ZendeskUnassignedTable from './zendeskUnassignedTable';

const ZendeskUnassigned: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false);

  const { communicationsData, communicationsError, communicationsMutate, isLoading } =
    useGetZendeskUnassignedCommunications();

  const handleErrorMessage = (errorString: string) => {
    setErrorMessage(errorString);
  };

  const handleRefresh = async () => {
    setIsRefreshLoading(true);

    await communicationsMutate();

    setIsRefreshLoading(false);
  };

  return (
    <div>
      <Header as="h3" color="red">
        <Icon name="users" size="mini" color="red" />
        <Header.Content>
          {"Zendesk Unassigned Communications"}{' '}
          <>
            {' '}
            <Icon name="refresh" onClick={handleRefresh} style={{ cursor: 'pointer' }} loading={isRefreshLoading} />
          </>
        </Header.Content>
      </Header>
      {isLoading && <Loader active inline="centered" />}
      {communicationsData && !communicationsData.entry && (
        <Message content="No Communications found!" header="Info" warning />
      )}
      {communicationsData && communicationsData.entry && !isLoading && (
        <ZendeskUnassignedTable
          communicationsData={communicationsData}
          communicationsMutate={communicationsMutate}
          handleErrorMessage={handleErrorMessage}
        />
      )}
      {communicationsError && !isLoading && (
        <Message negative>
          <Message.Header>Oops! Something went wrong.</Message.Header>
          <p>{communicationsError.message}</p>
        </Message>
      )}
      {errorMessage && (
        <Message content={errorMessage} onDismiss={() => handleErrorMessage('')} negative size="small" />
      )}
    </div>
  );
};

export default ZendeskUnassigned;
